// 统一处理 Cookie

import { CacheKey } from '@/constants/cache-key'
import Cookies from 'js-cookie'

export function getToken() {
  return Cookies.get(CacheKey.TOKEN)
}

export function setToken(token) {
  Cookies.set(CacheKey.TOKEN, token)
}

export function removeToken() {
  Cookies.remove(CacheKey.TOKEN)
}
